import { ThunkHelper } from 'invision-core';
import { values } from 'ramda';
export var RESEND_GIFT_NOTIFICATION = {
  BEGIN: 'RESEND_GIFT_NOTIFICATION_BEGIN',
  SUCCESS: 'RESEND_GIFT_NOTIFICATION_SUCCESS',
  FAILURE: 'RESEND_GIFT_NOTIFICATION_FAILURE'
};
export var RESEND_GIFT_NOTIFICATION_TYPES = values(RESEND_GIFT_NOTIFICATION);
var resendGiftNotificationPromise = function resendGiftNotificationPromise(dispatch, giftOrderInfo) {
  return ThunkHelper(dispatch, RESEND_GIFT_NOTIFICATION_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/ResendGiftOrderNotification',
    data: {
      NotifySender: true,
      OrderId: giftOrderInfo.orderId,
      RecipientEmail: giftOrderInfo.recipientEmail,
      RecipientName: giftOrderInfo.recipientName,
      SenderMessage: giftOrderInfo.giftMessage
    }
  });
};
export var submitResendGiftNotification = function submitResendGiftNotification(giftOrderInfo) {
  return function (dispatch) {
    return resendGiftNotificationPromise(dispatch, giftOrderInfo);
  };
};
export var SET_RESEND_GIFT_ORDER_INFO = 'SET_RESEND_GIFT_ORDER_INFO';
export var setResendGiftOrderInfo = function setResendGiftOrderInfo(giftOrderInfo) {
  return {
    type: SET_RESEND_GIFT_ORDER_INFO,
    payload: giftOrderInfo
  };
};
export var RESET_RESEND_GIFT_ORDER_INFO = 'RESET_RESEND_GIFT_ORDER_INFO';
export var resetGiftOrderInfo = function resetGiftOrderInfo() {
  return {
    type: RESET_RESEND_GIFT_ORDER_INFO
  };
};